var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendConfirmation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.57231L1.28213 5.38281C2.78375 6.11081 3.73461 6.66494 5.4209 7.8715C8.5926 4.26237 10.6879 2.431 14.5829 0L15 0.963625C11.7886 3.77488 9.43575 6.90625 6.04941 13C3.96058 10.5316 2.56587 8.95862 0 6.57231Z",
    fill: "#255056"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendConfirmation);
export default __webpack_public_path__ + "static/media/send-confirmation.6868ec2c6484a69c5107d52b3cd845db.svg";
export { ForwardRef as ReactComponent };